import {Component, OnInit} from "@angular/core";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import {WorkflowService} from "@ispm/workflow/services/workflow.service";
import {PdfService} from "@ispm/test/services/pdf.service";
import {NotificationMessageService} from "@ispm/core/components/customise-notification/notifications-message.service";

@Component({
  selector: 'documents-download-component',
  templateUrl: './documents-download.component.html',
  styleUrls: ['./documents-download.component.css']
})

export class DocumentsDownloadComponent implements OnInit {
  public fileName: string;
  public messageTitle: string = "Downloading...";
  public messageText: string;
  public closeWindowText: string;

  constructor(private routerManagerService: RouterManagerService, private workflowService: WorkflowService,
              private pdfService: PdfService, public notificationMessageService: NotificationMessageService) {
  }

  ngOnInit(): void {
    let fileId = this.routerManagerService.queryParameters.docUrl;
    this.fileName = this.routerManagerService.queryParameters.fileName;

    if (fileId) {
      if (!this.fileName)
        this.fileName = fileId + ".pdf"

      let fileBlobUrl = "blob:" + decodeURIComponent(fileId);
      console.log("#### DocumentsDownloadComponent => starting download file with Id: ", fileBlobUrl);
      this.messageTitle = "Download Complete";
      this.messageText = `'${this.fileName}' was downloaded.`;
      this.closeWindowText = "Please close the window.";
      this.pdfService.openDownloadLink(fileBlobUrl, this.fileName);
    } else
      this.fileName = "undefined";
  }
}
